import { PrivacyPolicyListItem, PrivacyPolicyParagraph } from './types';
import { TFunction } from 'i18next';

const renderListItems = (items: PrivacyPolicyListItem[], t: TFunction) => (
  <ul>
    {items.map(item =>
      item.type === 'list' && item.items ? (
        <li key={item.id}>
          {t(item.content)}
          {renderListItems(item.items, t)}
        </li>
      ) : (
        <li key={item.id}>{t(item.content)}</li>
      ),
    )}
  </ul>
);

export const renderParagraph = (paragraph: PrivacyPolicyParagraph, t: TFunction) => {
  if (paragraph.type === 'text') {
    const content = t(paragraph.content);
    return (
      <p
        key={paragraph.id}
        dangerouslySetInnerHTML={{
          __html: typeof content === 'string' ? content : '',
        }}
      />
    );
  }
  if (paragraph.type === 'list') {
    return <div key={paragraph.id}>{renderListItems(paragraph.items, t)}</div>;
  }
  return null;
};
